import React, { Component } from 'react'
import {NavBar, Icon} from 'antd-mobile';
import {parseSearchToState} from '../../util/util.js';
import NavBarComponent from '../../component/common/NavBarComponent';
import { connect } from 'react-redux';
import { orderCouponAdd } from '../../redux/actions/orderAction'
import './couponInstructions.scss';
class couponInstructions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:{
                name:'',
                amount:'',
                effectiveTerm:'',
                useTime:'',
                instructions:[],
                usableRange:'',
                fromType : '',//order 订单  mine 我的
            }
            
        };
    }
    componentDidMount = () => {
        const {location} = this.props;
        const search = location.search;
        const {
            name,
            amount,
            effectiveTerm,
            useTime,
            instructions,
            usableRange,
            enable,
            type
        } = parseSearchToState(decodeURIComponent(search));
        const data = {
            name:name,
            amount:amount,
            effectiveTerm:effectiveTerm,
            useTime:useTime,
            instructions:instructions.split(','),
            usableRange:usableRange,
            enable:enable,
            fromType:type
        }
        this.setState({
            data:data
        });
    }
    //去订单
    gotOrderPage = () => {
        if(this.state.data.enable == 0){
            return
        }
        const search = this.props.location.search;
        let data = parseSearchToState(decodeURIComponent(search))
        const {history} = this.props;
        if(this.state.data.fromType == 'order'){
            history.go(-2)
            this.props.dispatch(orderCouponAdd(data))
        }else{
            window.location.href = '/'
            // history.replace({
            //     pathname: '/',
            //     query:{
            //         type:'CouponInstructions'
            //     }
            // });
        }
    }
    render() {
        return <div id="couponInstruction" className="couponInstructions page">
            <div className="coupon-top">
                <NavBarComponent>
                    <NavBar
                        mode="light"
                        icon={ <Icon type="left" color="#ffffff" /> }
                        // leftContent="返回"
                        onLeftClick={ () => this.props.history.goBack() }
                        >
                            使用说明
                    </NavBar>
                </NavBarComponent>
            </div>
            <div className="wrapper">
                <div className="content">
                    <div className="content-title">
                        {this.state.data.name}  
                    </div>
                    <div className="discount-box">
                        <div className="discount-d-t">
                            <span className="discount-d">{this.state.data.amount}</span>
                            <span className="discount-t">天</span>
                        </div>
                        <div className="valid-time">{this.state.data.effectiveTerm}</div>
                    </div>
                    <div className="details-box">
                        <div className="details-item">
                            <div className="details-item-title">使用时间</div>
                            <p>
                            {this.state.data.useTime}
                            </p>
                        </div>
                        <div className="details-item">
                            <div className="details-item-title">使用说明</div>
                            {
                                this.state.data.instructions.map((item,index) =>(
                                    <p key={index}>
                                        {index+1}.{item}
                                    </p>
                                ))
                            }
                        </div>
                        <div className="details-item">
                            <div className="details-item-title">适用范围</div>
                            <p>
                                {this.state.data.usableRange}
                            </p>
                        </div>
                    </div>
                    <div className="touse">
                        <span className="left-semicircle"></span>
                        <span className="right-semicircle"></span>
                        <div className={this.state.data.enable == 0?"touse-btn nouse":"touse-btn"}  onClick={() =>  this.gotOrderPage()}>去使用</div>
                    </div>
                </div>
            </div>
        </div>
    }
}
const mapState =  connect(state => {
    const { orderReducer } = state
    return { orderReducer }
  });
export default mapState(couponInstructions);